import { USERS_LIST_GROUPS_COLLAPSE_THRESHOLD } from '../../dashboard/constants';

import userEditableWagesUrl from './userEditableWages.html';

class UserEditableWagesCtrl {
  filterHourlyWages = (w) => !w.isSalary;

  constructor(
    Authentication,
    Utils,
    UserUtils,
    displayNumberFilter,
    sdk,
    moneyDisplayFilter,
    $scope,
    $timeout
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      Utils,
      UserUtils,
      displayNumberFilter,
      sdk,
      moneyDisplayFilter,
      $scope,
      $timeout,
    });
  }

  $onInit() {
    this.USER_BASE_WAGE_KEY = this.sdk('constants').USER_BASE_WAGE_KEY;
    this.displayedItemsLimit = USERS_LIST_GROUPS_COLLAPSE_THRESHOLD;

    this.showAll = this.toggle(true);
    this.showLess = this.toggle(false);

    this.showLess(false);
    this.today = this.Utils.getNowDate();
    this.updateCurrentWages();
    this.editable = this.Authentication.user.isAdmin || !this.src.isManager;
  }

  $onChanges({ refreshCounter }) {
    if (refreshCounter && !refreshCounter.isFirstChange()) {
      this.updateCurrentWages();
    }
  }

  toggle =
    (state) =>
    (trigger = true) => {
      this.shouldShowAll = state;
      if (trigger) {
        this.$timeout(() => {
          this.$scope.$emit('vsRepeatTrigger');
        });
      }
    };

  updateCurrentWages() {
    this.currentWagePerPosition = this.getCurrentWages(this.src.wages);
    this.positionBaseWages = this.getPositionBaseWages(this.src.positions);
    this.displayWages = this.getDisplayWages(this.src.positions);
    this.displaySalaries = this.getDisplaySalaries(this.src.positions);
  }

  getCurrentWages(userWages) {
    const positionWages = {};

    Object.entries(userWages).forEach(([positionId, wages]) => {
      positionWages[positionId] = this.findCurrentWage(wages.filter(this.filterHourlyWages));
    });

    return positionWages;
  }

  getPositionBaseWages(positions) {
    const positionWages = {};

    positions.forEach((position) => {
      positionWages[position.id] = this.findCurrentWage(position.wages);
    });

    return positionWages;
  }

  findCurrentWage(wages) {
    let currentWage;
    let effectiveDate;

    wages.forEach((wage) => {
      if (wage.fromDate <= this.today && (!effectiveDate || effectiveDate < wage.fromDate)) {
        currentWage = wage;
        effectiveDate = wage.fromDate;
      }
    });

    return currentWage;
  }

  getDisplayWages(positions) {
    const displayWages = {};
    positions.forEach((position) => (displayWages[position.id] = this.getDisplayWage(position.id)));

    if (this.currentWagePerPosition[this.USER_BASE_WAGE_KEY]) {
      displayWages[this.USER_BASE_WAGE_KEY] = this.getDisplayWage(this.USER_BASE_WAGE_KEY);
    }

    return displayWages;
  }

  getDisplaySalaries(positions) {
    const displaySalaries = {};
    positions.forEach(
      (position) => (displaySalaries[position.id] = this.getDisplaySalary(position.id))
    );
    return displaySalaries;
  }

  getDisplaySalary(positionId) {
    if (this.src.currentSalary && this.src.currentSalary.positionId === positionId) {
      return {
        currentWage: this.src.currentSalary.regularRate,
        emptyLabel: '-',
      };
    }

    return {
      currentWage: null,
      emptyLabel: '-',
    };
  }

  getDisplayWage(positionId) {
    const currentWage = this.currentWagePerPosition[positionId];
    if (currentWage) {
      return {
        currentWage: currentWage.regularRate,
        emptyLabel: '-',
      };
    }

    const positionBaseWage = this.positionBaseWages[positionId];
    if (positionBaseWage) {
      return {
        currentWage: null,
        emptyLabel: `${this.moneyDisplayFilter(positionBaseWage.regularRate)} Position base wage`,
      };
    }

    const userBaseWage = this.currentWagePerPosition[this.USER_BASE_WAGE_KEY];
    if (userBaseWage) {
      return {
        currentWage: null,
        emptyLabel: `${this.moneyDisplayFilter(userBaseWage.regularRate)} Employee base wage`,
      };
    }

    return {
      currentWage: null,
      emptyLabel: '-',
    };
  }

  updateSalary(rate) {
    if (this.src.currentSalary.regularRate !== rate) {
      if (this.Utils.formatDate(this.src.currentSalary.fromDate) === this.Utils.formatDate()) {
        this.wagesToSave[this.src.id] = {
          ...this.wagesToSave[this.src.id],
          [this.src.currentSalary.positionId]: {
            ...this.src.currentSalary,
            regularRate: rate,
          },
        };
      } else {
        const fromDate = this.UserUtils.getSalaryDefaultDate(this.src);
        const wageToSave = {
          regularRate: rate,
          fromDate,
          dateEffective: this.Utils.formatDate(fromDate),
          userId: this.src.id,
          positionId: this.src.currentSalary.positionId,
          locationId: this.src.currentSalary.locationId,
          isSalary: true,
        };

        if (typeof rate === 'string' && !rate) {
          wageToSave.id = this.src.currentSalary.id;
        }

        this.wagesToSave[this.src.id] = {
          ...this.wagesToSave[this.src.id],
          [wageToSave.positionId]: wageToSave,
        };
      }
    }
  }

  updateWage(wage, positionId) {
    const currentWage = this.currentWagePerPosition[positionId];
    const userId = this.src.id;

    if (!currentWage) {
      const fromDate = this.UserUtils.getWageDefaultDate(this.src, positionId);
      this.wagesToSave[userId] = {
        ...this.wagesToSave[userId],
        [positionId]: {
          regularRate: wage,
          fromDate,
          dateEffective: this.Utils.formatDate(fromDate),
          userId,
          positionId,
        },
      };
    } else if (currentWage.regularRate !== wage) {
      if (this.Utils.formatDate(currentWage.fromDate) === this.Utils.formatDate()) {
        this.wagesToSave[userId] = {
          ...this.wagesToSave[userId],
          [positionId]: {
            ...currentWage,
            regularRate: wage,
          },
        };
      } else {
        const fromDate = this.UserUtils.getWageDefaultDate(this.src, positionId);
        const wageToSave = {
          regularRate: wage,
          fromDate,
          dateEffective: this.Utils.formatDate(fromDate),
          userId,
          positionId,
        };

        if (typeof wage === 'string' && !wage) {
          wageToSave.id = currentWage.id;
        }

        this.wagesToSave[userId] = {
          ...this.wagesToSave[userId],
          [positionId]: wageToSave,
        };
      }
    }
  }
}

export default {
  controller: UserEditableWagesCtrl,
  controllerAs: 'ctrl',
  templateUrl: userEditableWagesUrl,
  bindings: {
    src: '=',
    wagesToSave: '=',
    comma: '=?',
    shouldShowAll: '=isExpanded',
    cancelCounter: '<',
    saveCounter: '<',
    refreshCounter: '<',
  },
};
